import { SCAN_DATA_PLACEMENT_SELECT_ITEMS } from './constants';

export const renderScanDataPlacementValue = (selected: unknown) => {
  if (selected === '' || selected == null) {
    return '\u00a0';
  }
  return (
    SCAN_DATA_PLACEMENT_SELECT_ITEMS.find((i) => i.value === selected)?.label ?? String(selected)
  );
};

/** Form value is `number | string | undefined`; string is used for in-progress decimal input. */
export const formatScanDataDiscountAllocation = (value: unknown): string => {
  if (typeof value === 'string') return value;
  if (typeof value === 'number' && Number.isFinite(value)) {
    return String(value);
  }
  return '';
};

export const parseScanDataDiscountAllocation = (value: string): number | string | undefined => {
  const trimmed = value.trim();
  if (trimmed === '') return undefined;
  // Preserve "0." so the decimal point isn't stripped while the user is still typing
  if (/^\d+\.$/.test(trimmed)) return trimmed;
  const n = parseFloat(trimmed);
  if (Number.isNaN(n) || !Number.isFinite(n)) return undefined;
  return Math.max(0, n);
};
